import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../config/fbConfig';
import Logo from '../images/school_logo.png';

const FeesClasses = () => {
  const [classes, setClasses] = useState([]);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentTerm, setCurrentTerm] = useState({ sessionId: '', termId: '' });
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCurrentTermClasses = async () => {
      try {
        // Fetch current term data
        const currentTermDoc = await getDoc(doc(db, "current-term", "current"));
        if (!currentTermDoc.exists()) {
          console.error("Current term document does not exist");
          setClasses([]);
          setFilteredClasses([]);
          setLoading(false);
          return;
        }
        const currentTermData = currentTermDoc.data();
        const currentSessionId = currentTermData?.sessionId;
        const currentTermId = currentTermData?.termId;

        if (!currentSessionId || !currentTermId) {
          console.error("Current session or term not found", { currentSessionId, currentTermId });
          setClasses([]);
          setFilteredClasses([]);
          setLoading(false);
          return;
        }

        setCurrentTerm({ sessionId: currentSessionId, termId: currentTermId });

        // Fetch classes for the current term and session
        const q = query(
          collection(db, 'classes'),
          where('session', '==', currentSessionId),
          where('term', '==', currentTermId)
        );
        const snap = await getDocs(q);
        const classesData = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        
        // Fetch section names for display
        const sectionsQuery = query(collection(db, "sections"));
        const sectionsSnapshot = await getDocs(sectionsQuery);
        const sectionsData = Object.fromEntries(
          sectionsSnapshot.docs.map(doc => [doc.id, doc.data().name])
        );

        // Fetch session and term names for breadcrumb
        const sessionsQuery = query(
          collection(db, "sessions"),
          where("__name__", "==", currentSessionId)
        );
        const sessionsSnapshot = await getDocs(sessionsQuery);
        const sessionsData = Object.fromEntries(
          sessionsSnapshot.docs.map(doc => [doc.id, doc.data().name])
        );

        const termsQuery = query(
          collection(db, "terms"),
          where("__name__", "==", currentTermId)
        );
        const termsSnapshot = await getDocs(termsQuery);
        const termsData = Object.fromEntries(
          termsSnapshot.docs.map(doc => [doc.id, doc.data().name])
        );

        // Combine class data with section names
        const enrichedClasses = classesData.map(cls => ({
          ...cls,
          sectionName: sectionsData[cls.section] || "Unknown Section",
          sessionName: sessionsData[currentSessionId] || "Unknown Session",
          termName: termsData[currentTermId] || "Unknown Term"
        })).sort((a, b) => a.name.localeCompare(b.name));

        setClasses(enrichedClasses);
        setFilteredClasses(enrichedClasses);
      } catch (error) {
        console.error('Error fetching current term classes:', error);
        setClasses([]);
        setFilteredClasses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCurrentTermClasses();
  }, []);

  // Filter classes based on search term
  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = classes.filter(cls => 
      cls.name.toLowerCase().includes(lowerSearchTerm) ||
      cls.sectionName.toLowerCase().includes(lowerSearchTerm)
    );
    setFilteredClasses(filtered);
  }, [searchTerm, classes]);

  return (
    <>
      <div className="top-elements row align-center space-between">
        <button onClick={() => navigate(-1)} className="back-link back-link1">
          <i className="fa-solid fa-arrow-left size3"></i>
        </button>
        <div className="column align-center justify-center">
          <img src={Logo} className="middle-logo" alt="logo" />
        </div>
        <RouterLink to="#" className="home-link" onClick={() => window.location.reload()}>
          <i className="fa-solid fa-rotate-right size4"></i>
        </RouterLink>
      </div>

      <div className="login-page-items column align-center">
        <div className='breadcrumb'>
          <button onClick={() => navigate(-1)} className="back-link back-link1 back-link2">
            Management &nbsp;&nbsp;&nbsp;<i className="fa-solid fa-angle-right font-gold size4"></i>
          </button>
          <button className="back-link back-link1 back-link2">
          Select Class ({currentTerm.termId ? `${classes[0]?.termName || 'Current'} Term` : 'Loading...'})
          </button>
        </div>
          <input
            type="text"
            className="input-field1 management-search-input"
            placeholder="Search by class or section..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        <div className="scroll-fixed scroll-fixed2">
          <div className="class-list class-list-d scrollable class-items">
            {loading ? (
              <p className="loading-text male-female-stat">Loading classes...</p>
            ) : filteredClasses.length === 0 ? (
              <p className="empty-text male-female-stat">No classes found for the current term or search.</p>
            ) : (
              filteredClasses.map(cls => (
                <div key={cls.id}>
                  <RouterLink
                    to={`/fees/${cls.id}`}
                    className="class-item class-item1 class-item1-d"
                  >
                    {cls.name} <span className='size5 bold'>{cls.sectionName}</span>
                  </RouterLink>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default FeesClasses;